<template>
  <div>

    <span
      class="text-3xl font-bold lg:text-4xl"
    >
      ${{this.myCampaign.formattedTotalRaisedWithChildrenCampaigns}}
      <span
        class="text-xl font-medium lg:text-2xl"
      >Raised</span>
    </span>

    <div id="progress-bar"
      class="w-full h-8 my-2 relative overflow-hidden rounded-full"
      style="background: #cddce3;"
    >
      <div id="progress-indicator" :style="{width: this.progressCounter+'%'}" class="h-8 transition duration-500 ease-in-out overflow-hidden">
        <div
          :class="{
            'rounded-full h-full': true,
            'slanted-end': formattedFundedPercentage < 100
          }"
          class="w-full bg-green relative">
          &nbsp;
        </div>
      </div>
    </div><!-- .progress -->

      <div class="flex justify-between">
      <span
        class="text-md text-base font-medium lg:text-xl"
      > {{formattedFundedPercentage}}% Funded</span>
      <span
        class="text-md text-gray font-medium lg:text-xl"
      >${{myCampaign.goal}} Goal</span>
    </div>
  </div><!-- .myCampaign-raised -->
</template>

<script>
  export default {
    name: 'StandardCampaignGoal',
    props: {
      campaignId: {
        type: String,
        required: true,
      },
      campaign: {
        required: true,
      },
    },

    data() {
      return {
        progressCounter: 0,
        myCampaign: this.campaign,
      }
    },

    created() {
      this.emitter.on('campaign-donation-update', (campaign) => {
        this.myCampaign = campaign
        this.progressCounter = this.myCampaign.funded
      })
    },

    async mounted() {
      this.timer = setInterval(() => {
        this.progressCounter = this.campaign.funded
      }, 1000)
    },

    computed: {
      formattedFundedPercentage() {
        return Math.min(this.myCampaign.funded || 0, 100);
      }
    },

    beforeUnmount() {
      clearInterval(this.timer);
    }

  }
</script>

<style scoped>
.slanted-end::after {
  content: '';
  position: absolute;
  right: -30px; /* Adjust this value as needed */
  top: 0;
  width: 30px; /* Width of the slanted part */
  height: 100%;
  background-color: #cddce3;
  transform: skewX(-45deg);
  transform-origin: top right;
}

</style>
